import employee from './role'

export const queries = {
  employee,
}
export default queries
